import { render, staticRenderFns } from "./TheFilter.vue?vue&type=template&id=0c88053e"
import script from "./TheFilter.vue?vue&type=script&lang=js"
export * from "./TheFilter.vue?vue&type=script&lang=js"
import style0 from "./TheFilter.vue?vue&type=style&index=0&id=0c88053e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports